module.exports = __webpack_public_path__ + "static/media/channel_zester.40159325.png";